import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import NavItem from "@ats/src/components/shared/NavItem";
import FormCheckbox from "@ats/src/components/forms/FormCheckbox";
import { FeatureFlipper } from "@ats/src/components/shared/FeatureFlipper";
import { FitHarvey, fitBand } from "@ats/src/views/jobApplications/Plato/FitIndicator";
import PlatoHourglass from "@ats/src/components/shared/PlatoHourglass";

interface Props {
  id: number;
  to: string;
  icon: string;
  label: string;
  onChange?: (id, applicationsCount) => void;
  checked?: boolean;
  applicationsCount: number;
  summaryStatus?: string | null;
  summaryScorePercentage?: number | null;
  bulkAiSummaryProcessing?: boolean;
}

function JobApplicationNavItem({ id, applicationsCount, summaryStatus, summaryScorePercentage, bulkAiSummaryProcessing, ...props }: Props) {
  const onChangeSelect = () => {
    props.onChange(id, applicationsCount);
  };

  const harveyValue =
    (summaryStatus === "current" || summaryStatus === "regenerating") && summaryScorePercentage != null
      ? fitBand(summaryScorePercentage).fill
      : null;

  const showHourglass =
    harveyValue == undefined && (summaryStatus === "initial_summary_pending" || bulkAiSummaryProcessing);

  const platoIndicator = harveyValue != undefined
    ? <FitHarvey value={harveyValue} label={fitBand(summaryScorePercentage).label} size={12} />
    : showHourglass
      ? <PlatoHourglass size={12} title="Review in progress" />
      : null;

  const rightContent = platoIndicator && (
    <FeatureFlipper feature="AI_APPLICANT_SUMMARY">{platoIndicator}</FeatureFlipper>
  );

  return (
    <Styled.Container>
      <FormCheckbox
        name={`jobApplicationItem-${id}`}
        label=" "
        checked={props.checked}
        onChange={onChangeSelect}
      />
      <NavItem
        to={props.to}
        label={props.label}
        chevron
        rightContent={rightContent}
      />
    </Styled.Container>
  );
}

export default JobApplicationNavItem;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: JobApplicationNavItem;
    display: flex;
    position: relative;
    width: 100%;
    ${[t.pl(2)]}

    a {
      margin-left: -8px;
      width: calc(100% - 32px);
    }
  `;
});

